import React from 'react';
import { fonts, colors } from '@peachjar/components';
import config from '../../../../config';

const { REACT_APP_ACCOUNTS_APP_URL, REACT_APP_SCHOOL_ONBOARDING_URL } = config;
const { jungle } = colors;
const { ProximaNova } = fonts;

const getCurrentUrl = () => REACT_APP_SCHOOL_ONBOARDING_URL; // TODO, add route or use router state

// FIXME change this name
const TempRightActionHelper = () => (
  <p
    style={{
      padding: '1rem',
      marginRight: '.5rem',
      fontSize: '13px',
      fontFamily: ProximaNova,
    }}
  >
    Have an account?{' '}
    <a
      href={`${REACT_APP_ACCOUNTS_APP_URL}/?redirect=${encodeURI(
        getCurrentUrl()
      )}`}
      style={{ textDecoration: 'none', color: jungle }}
    >
      Log in
    </a>
  </p>
);

export default TempRightActionHelper;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/components/TempRightActionHelper.jsx